


















import { Component, Prop, Vue } from 'vue-property-decorator';
import SearchProductControl from '@/project/search/SearchProductControl.vue';
import { PageName } from '@/router/routes/constants';
import { CampaignPageViewModel, PageData } from '@/types/contentServerContract';
import dictionaryService from '@/core/translation/dictionary.service';
import domService from '@/core/dom/dom.service';
import appStore from '@/core/app/app.store';
import CategoryFacets from '@/project/search/facets/CategoryFacets.vue';
import { upperFirst } from 'lodash';
import urlStringHelperService from '@/core/urlStringHelper.service';

@Component({
    components: { SearchProductControl, CategoryFacets }
})
export default class CampaignPage extends Vue {
    @Prop(String)
    private campaignCode!: string;

    private campaignName: string | null = null;
    hideLeftMenu: boolean = false;

    private get pageDataUrl() {
        const pageUrl = urlStringHelperService.prependCulturePrefix(this.$route.path);
        return pageUrl;
    }

    private async handlePageDataCallback(pageData?: PageData) {
        this.hideLeftMenu = pageData?.navigation?.hideLeftMenu ?? false;
        const breadcrumb = pageData?.navigation?.breadcrumb ?? appStore.getBreadcrumbFromRoute(this.$route.fullPath);
        appStore.setBreadcrumb(breadcrumb);

        // Special case to be able to overwrite campaign name
        if (pageData) {
            const campaignPageData = pageData.jsonContent.content as CampaignPageViewModel;
            if (campaignPageData) {
                this.campaignName = campaignPageData.campaignName ?? null;
            }
        } else {
            this.campaignName = breadcrumb[breadcrumb.length - 1].name;
        }

        const name = this.campaignName || this.campaignCode;
        const title = pageData?.metadata?.seoTitle ?? dictionaryService.get('Campaigns.SEO.Title', [upperFirst(name)]);
        const description = pageData?.metadata?.seoDescription ?? dictionaryService.get('Campaigns.SEO.Description', [name]);

        domService.setTitle(title);
        domService.setDescription(description);
    }

    private get categoryUrlBase() {
        return `/${PageName.CAMPAIGN}/${this.campaignCode}`;
    }
}
